module.exports = __webpack_public_path__ + "static/social_branding-5d3981c41dc53d7546dc0c9644debd18.jpg";